<template>
  <div>
    
    <b-modal id="dataModal" ref="dataModal" size="lg" :title="title">
      <form>

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="outlet"
            label="text"
            track-by="id"
            :options="outletSelect"
            :searchable="false"
            :show-labels="false"
            :disabled="this.dataID ? true : false"
            openDirection="below">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="form-group">
          <label class="form-label">Room Name</label>
          <input
            class="form-control bg-transparent pl-3"
            v-model="name">
        </div>

        <div class="form-group">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="room-disable" v-model="enable">
                <label class="custom-control-label" for="room-disable">Enable</label>
            </div>
        </div>

      </form>
      <template #modal-footer="{ close }">
        <div class="row w-100">
          <div v-if="false && showDelete" class="col-auto">
            <b-button variant="warning" @click="confirmDeleteItem">Delete</b-button>
          </div>
          <div class="col">
          </div>
          <div class="col-auto">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
          </div>
          <div class="col-auto">
            <b-button class="ml-1" variant="primary" @click="save">{{ $t('button_link.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="confirmDeleteModal" ref="confirmDeleteModal" size="lg" title="Delete Room">
      <div>Are you sure you want to delete this room?</div>
      <template #modal-footer="{ close }">
        <div class="row w-100">
          <div class="col">
          </div>
          <div class="col-auto">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
          </div>
          <div class="col-auto">
            <b-button class="ml-1" variant="primary" @click="deleteItem">Yes</b-button>
          </div>
        </div>
      </template>
    </b-modal>

  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import Swal from "sweetalert2";

export default {
  name: 'roomForm',
  props: {
    outlets: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
    staffs: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
  },
  components: {
    // DateRangePicker
  },
  data() {
    let temp = moment().add(1, 'day').startOf('day').toDate()

    return {
      title: '',
      showDelete: false,
      showSpace: false,
      statuses: [
        { value: 'approved', text: 'Approved' },
        { value: 'rejected', text: 'Rejected' },
      ],
      staffsSelect: [],
      outletSelect: [],

      dataID: '',
      outlet: null,
      name: '',
      enable: true,
    }
  },
  watch: {
    "$i18n.locale"(val) {
    },
    outlet(val) {
      this.outletSelect = []
      let outletInSelection = false
      for(let outlet of this.outlets) {
        if(outlet['id'] !== 'all') {
          this.outletSelect.push(outlet)

          if(this.outlet['id'] === outlet['id']) {
            outletInSelection = true
          }
        }
      }

      if(!outletInSelection) {
        this.outlet = this.outletSelect[0]
      }
    },
  },
  methods: {
    onDateStartChange(date) {
      this.dateStart = date
      this.dateEndMin = date['startDate']

      if (this.dateEnd && this.dateEnd['startDate'] && this.dateEnd['startDate'].getTime() < date['startDate'].getTime()) {
        this.dateEnd = date
      }
    },
    onDateEndChange(date) {
      this.dateEnd = date
    },
    show(outlet, item, date) {
      this.$refs['dataModal'].show()

      this.outlet = outlet
      
      if (!item) {
        this.title = 'Add Room'
        this.showDelete = false

        this.dataID = ''
        this.name = ''
        this.enable = true

        return
      }

      this.title = 'Edit Room'
      this.showDelete = true

      this.dataID = item['roomID']
      this.name = item['name']
      this.enable = item['disableDate'] ? false : true
    },

    save() {
      let request = {}
      request['name'] = this.name
      request['outletID'] = this.outlet['id']

      let url
      if (this.dataID) {
        url = `https://staff.tunai.io/business/rooms/${this.dataID}/update`
      } else {
        url = `https://staff.tunai.io/business/rooms`
      }

      this.$axios({
        method: 'post',
        url: url,
        headers: { token: this.$util.getSessionToken() },
        data: request,
      })
        .then((response) => {
          this.saveEnableDisable(response.data.rooms[0].roomID)
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },
    saveEnableDisable(roomID) {
      let url = `https://staff.tunai.io/business/rooms/${roomID}/disable`
      
      let request = {}
      request['disable'] = this.enable ? 0 : 1

      this.$axios({
        method: 'post',
        url: url,
        headers: { token: this.$util.getSessionToken() },
        data: request,
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: this.dataID ? 'Update Room' : 'Add Room',
            text: this.dataID ? 'Successfully update room' : 'Successfully add room',
          });

          this.$refs['dataModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },
    confirmDeleteItem() {
      this.$refs['confirmDeleteModal'].show()
    },
    deleteItem() {
      let url = `https://staff.tunai.io/business/rooms/${this.dataID}/delete`

      this.$axios({
        method: 'post',
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$util.getSessionToken() },
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: 'Delete Room',
            text: 'Successfully delete room',
          });

          this.$refs['confirmDeleteModal'].hide()
          this.$refs['dataModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },

    closeModal(isError) {
      if (!isError) {
        this.$refs['dataModal'].hide()
        this.$emit('onModalClose')
      }
    }
  },
  async mounted() {
  }
}
</script>
<style scoped>
.show {
  display: block;
}

.nav-link,
.link {
  cursor: pointer;
}

.img-thumbnail {
  width: 20em;
}

.item-image {
  width: 8em;
  opacity: .5;
}

.error-validation {
  font-size: 0.6875rem;
  margin-top: 0.325rem;
  color: #fd3995;
}
</style>